import { Typography } from "@mui/material";
import Datatable from "../../../components/dataTables/DataTable";
import AdminApi from "../../../config/apis/admin";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Moment from "react-moment";
import { AddFriend } from "./add";
import styles from "./style.module.css";
import { ViewFriendDetails } from "./ViewFriendDetails";

export const FriendsOfCGGrid = (props) => {
  const navigate = useNavigate();

  const tableColumns = [
    {
      selector: (row) => (
        <>
          <Typography variant="body2" fontWeight={"700"}>
            {row.partner_type}
          </Typography>
        </>
      ),
      selector: "partner_type",
      name: "Type",
      sortable: true,
      minWidth: "150px",
    },
    {
      selector: (row) => (
        <>
          <Typography variant="body2" fontWeight={"700"}>
            {row.partner_placement}
          </Typography>
        </>
      ),
      selector: "partner_placement",
      name: "Category",
      sortable: true,
      minWidth: "180px",
    },
    {
      selector: (row) => (
        <>
          <Typography variant="body2" fontWeight={"700"}>
            {row.organization}
          </Typography>
        </>
      ),
      selector: "organization",
      name: "Organization",
      sortable: true,
      minWidth: "250px",
    },
    {
      selector: (row) => (
        <>
          <Typography variant="body2">
            {row.website_url ? (
              <a
                href={row.website_url}
                target="_blank"
                rel="noopener noreferrer"
              >
                {row.website_url}
              </a>
            ) : (
              "-"
            )}
          </Typography>
        </>
      ),
      selector: "website_url",
      name: "Website",
      sortable: true,
      minWidth: "200px",
    },
    {
      selector: (row) => (
        <>
          <Typography variant="body2" fontWeight={"700"}>
            {row.contact_person}
          </Typography>
        </>
      ),
      selector: "contact_person",
      name: "Contact Person",
      sortable: true,
      minWidth: "200px",
    },
    {
      selector: (row) => (
        <>
          <Typography variant="body2">{row.email}</Typography>
        </>
      ),
      selector: "email",
      name: "Email",
      sortable: true,
      minWidth: "220px",
    },

    {
      selector: (row) => (
        <>
          <Typography variant="body2">
            {row.last_interaction ? (
              <Moment format="DD/MM/YYYY">{row.last_interaction}</Moment>
            ) : (
              "-"
            )}
          </Typography>
        </>
      ),
      selector: "last_interaction",
      name: "Last Interaction",
      sortable: true,
      minWidth: "150px",
    },
    {
      name: "Status",
      sortable: true,
      minWidth: "120px",
      selector: "status",
      selector: (row) => {
        const status = Number(row.status); // ensures it's a number
        return (
          <Typography variant="body2">
            {status === 1 ? "Active" : status === 0 ? "Inactive" : "-"}
          </Typography>
        );
      },
    },
    {
      selector: (row) => (
        <>
          <Typography variant="body2" fontWeight={"700"}>
            {row.comment}
          </Typography>
        </>
      ),
      selector: "comment",
      name: "Comments",
      sortable: true,
      minWidth: "120px",
    },
  ];

  const [addModalOpen, setAddModalOpen] = useState(false);
  const [viewModalOpen, setViewModalOpen] = useState(false);
  const [editFriendId, setEditFriendId] = useState(null);
  const [formSuccess, setFormSuccess] = useState(false);
  const [reRender, setReRender] = useState(false);
  const [selectedFriendId, setSelectedFriendId] = useState(null);

  const handleCloseAddModal = () => {
    setAddModalOpen(false);
    setEditFriendId(null);
  };
  
  const handleCloseViewModal = () => {
    setViewModalOpen(false);
  };

  const onEdit = (id) => {
    setEditFriendId(id);
    setAddModalOpen(true);
  };

  // When form is successfully submitted
  useEffect(() => {
    if (formSuccess) {
      setReRender(!reRender); // Toggle reRender to refresh the table
      setAddModalOpen(false);  // Close the modal
      setEditFriendId(null);   // Reset edit ID
      setFormSuccess(false);   // Reset success state
    }
  }, [formSuccess]);

  // Handle prop modalOpen change
  useEffect(() => {
    if (props.modalOpen) {
      setAddModalOpen(true);
      setEditFriendId(null); // Ensure we're in "add" mode, not "edit" mode
    }
  }, [props.modalOpen]);

  // Sync modal state back to parent
  useEffect(() => {
    if (props.setModalOpen && !addModalOpen) {
      props.setModalOpen(false);
    }
  }, [addModalOpen, props.setModalOpen]);

  const onView = (id) => {
    setSelectedFriendId(id);
    setViewModalOpen(true);
  };

  return (
    <>
      <div
        className={`page-container table-phases ${styles.FRIENDS_OF_CG_PAGINATION}`}
      >
        <Datatable
          tableColumns={tableColumns}
          dataUrl={AdminApi.FRIENDS_OF_CG_PAGINATION}
          qureyParam={props.filters ?? ""}
          sortOrder={props.currentValue}
          actions={{
            view: true,
            edit: true,
            delete: false,
          }}
          onView={onView}
          onEdit={onEdit}
          module="manage-friends-of-codegirls"
          refreshHandle={reRender}
        />
      </div>
      <AddFriend
        modalOpen={addModalOpen}
        handleCloseModal={handleCloseAddModal}
        setModalOpen={setAddModalOpen}
        setFormSuccess={setFormSuccess}
        formSuccess={formSuccess} // Pass formSuccess as prop
        editId={editFriendId}
      />

      <ViewFriendDetails
        viewId={selectedFriendId}
        modalOpen={viewModalOpen}
        setModalOpen={setViewModalOpen}
      />
    </>
  );
};